import { Component, Input, inject, ChangeDetectionStrategy } from "@angular/core";
import { differenceInHours, differenceInDays, differenceInWeeks, differenceInMonths, differenceInYears } from "date-fns";
import { FormattingService } from "root/services";

import { ResourceStringComponent } from 'root/shared/components/localization/resource-string/resource-string.component';


@Component({
  selector: 'mibp-time-ago',
  templateUrl: './time-ago.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ResourceStringComponent]
})
export class MibpTimeAgoComponent {
  private formatting = inject(FormattingService);


  resourceStringKey?: string;
  number?: number;
  formattedTime?: string;
  currentDate?: Date;
  readonly resourceStringPrefix = 'Global_Abbrevation_';

  constructor() {}

  @Input()
  set date(date: Date | string) {
    this.currentDate = date ? this.formatting.toDate(date) : null;
    this.refresh();
  }

  private refresh(): void {

    if (this.currentDate) {
      const now = new Date();

      this.formattedTime = null;
      const diffInHours = differenceInHours(now, this.currentDate);
      const diffInDays = differenceInDays(now, this.currentDate);
      const diffInWeeks = differenceInWeeks(now, this.currentDate);
      const diffInMonths = differenceInMonths(now, this.currentDate);
      const diffInYears = differenceInYears(now, this.currentDate);

      if (diffInYears > 1) {
        this.number = diffInYears;
        this.resourceStringKey = `${this.resourceStringPrefix}Years`;
      } else if (diffInMonths > 1) {
        this.number = diffInMonths;
        this.resourceStringKey = `${this.resourceStringPrefix}Months`;
      } else if (diffInWeeks > 1) {
        this.number = diffInWeeks;
        this.resourceStringKey = `${this.resourceStringPrefix}Weeks`;
      } else if (diffInDays > 1) {
        this.number = diffInDays;
        this.resourceStringKey = `${this.resourceStringPrefix}Days`;
      } else if (diffInHours < 6) {
        this.formattedTime = this.formatting.formatTime(this.currentDate);
      } else {
        this.number = diffInHours;
        this.resourceStringKey = `${this.resourceStringPrefix}Hours`;
      }

    } else {
      this.formattedTime = null;
      this.number = 0;
    }
  }






}
